export default __webpack_public_path__ + "fonts/grove-icons.woff2";